// Lesha Bank in the browser's chrome (the "New design" flag on): the tab icon, the touch icon, the app name, and the
// tab title before a page names itself. index.html keeps Datox for the flag-off app; this swaps it at boot, so the
// sign-in page and a direct load show the bank too.

export const LESHA_ICON = "/lesha-favicon.svg"
export const LESHA_TOUCH_ICON = "/lesha-apple-touch-icon.png"
export const LESHA_MANIFEST = "/lesha.webmanifest"

export function applyLeshaHead(doc: Document, name: string) {
  doc.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="shortcut icon"]').forEach((link) => link.remove())
  const icon = doc.createElement("link")
  icon.rel = "icon"
  icon.type = "image/svg+xml"
  icon.href = LESHA_ICON
  doc.head.append(icon)
  link(doc, "apple-touch-icon", LESHA_TOUCH_ICON)
  link(doc, "manifest", LESHA_MANIFEST)
  for (const meta of ["application-name", "apple-mobile-web-app-title"]) doc.querySelector(`meta[name="${meta}"]`)?.setAttribute("content", name)
  doc.querySelector('meta[property="og:title"]')?.setAttribute("content", name)
  doc.querySelector('meta[property="og:site_name"]')?.setAttribute("content", name)
  doc.title = name
}

function link(doc: Document, rel: string, href: string) {
  const existing = doc.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (existing) {
    existing.href = href
    existing.removeAttribute("sizes")
    return
  }
  const created = doc.createElement("link")
  created.rel = rel
  created.href = href
  doc.head.append(created)
}

// The tab title of a page in the V2 shell: pages that name themselves (the reports list, the editor and a report) own
// it; every other page is "<its rail label> — Lesha Bank", or the bank's name alone.
export function ownsTitle(pathname: string) {
  return /^\/reports(?:\/[^/]+\/[^/]+)?\/?$/.test(pathname) || /^\/catalog\/[^/]+\/[^/]+\/[^/]+\/[^/]+\/?$/.test(pathname)
}
